import { Controller } from "@hotwired/stimulus"

// Toggles dropdown panel on trigger click; closes on outside click. Fade + slide via CSS.
export default class extends Controller {
  static targets = ["trigger", "panel"]

  connect() {
    this.boundClose = this.closeOnOutsideClick.bind(this)
    this.boundKeydown = this.closeOnEscape.bind(this)
  }

  disconnect() {
    document.removeEventListener("click", this.boundClose)
    document.removeEventListener("keydown", this.boundKeydown)
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()
    if (this.panelTarget.classList.contains("header-dropdown-open")) {
      this.close()
    } else {
      this.open()
    }
  }

  open() {
    this.panelTarget.classList.add("header-dropdown-open")
    document.addEventListener("click", this.boundClose)
    document.addEventListener("keydown", this.boundKeydown)
  }

  close() {
    this.panelTarget.classList.remove("header-dropdown-open")
    document.removeEventListener("click", this.boundClose)
    document.removeEventListener("keydown", this.boundKeydown)
  }

  closeOnOutsideClick(event) {
    if (this.element.contains(event.target)) return
    this.close()
  }

  closeOnEscape(event) {
    if (event.key !== "Escape") return
    this.close()
    this.triggerTarget?.focus()
  }
}
